import type { PayloadAction } from '@reduxjs/toolkit';
import type { ContentReducerCreator } from '../types';
import type { StaticVideo } from '@/types/video.types';

const addUploadedVideo = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<StaticVideo>) => {
    if (state.uploadedVideos) {
      state.uploadedVideos.unshift(action.payload);
    } else {
      state.uploadedVideos = [action.payload];
    }
  });
};

export default addUploadedVideo;
